import { render, staticRenderFns } from "./SearchbarWrapper.vue?vue&type=template&id=52376f29&lang=pug&"
import script from "./SearchbarWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchbarWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports